export default "__VITE_ASSET__CsTw829e__"